<template>
    <div class="row" key="zonas" id="zonas">
        <div class="col-lg-8">
            <h3 class="subtitle h3 light mb-3 ">A) {{ $t('partido.pinchando_mapa') }}:</h3>
            <div class="lightgray-content">
                <div>
                    <SvgComponent
                            :zonas="zonas"
                            :place="pack.recinto"
                            @clickZona="zonaSeleccionada"
                    />
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <h3 class="subtitle h3 light mb-3 ">B) {{ $t('partido.tabla') }}:</h3>
            <div class="lightgray-content p-2 pb-0">
                <TablaSectoresComponent :zonas="zonas_formated" @goTo="zonaSeleccionada"></TablaSectoresComponent>
            </div>
        </div>
    </div>
</template>

<script>
import SvgComponent from "@/components/svg/SvgComponent.vue";
import TablaSectoresComponent from "@/components/frontend/events/compra/TablaSectoresComponent.vue";

export default {
    props: {
        zonas: {
            required: true,
            type: Array
        },
        pack: {
            type: Object,
            required: true
        },
        precios_seleccionados: {
            type: Array,
            required: false,
            default() {
                return []
            }
        }
    },
    methods: {
        zonaSeleccionada(zona) {
            this.$emit('zonaSeleccionada', zona);
        }
    },
    computed: {
        zonas_formated() {
            const array = [];
            for(let zona in this.zonas) {
                array.push(this.zonas[zona]);
                let disponible = array[zona].precios.length > 0 && array[zona].libres > 0 ? true : false;

                if(this.precios_seleccionados.length > 0 && disponible) {
                    this.precios_seleccionados.forEach(precio => {
                        let encontrado = array[zona].precios.find(element => element.id === precio);
                        if(encontrado === undefined) {
                            disponible = false;
                        }
                    })
                }

                array[zona].esta_disponible = disponible;
            }

            return array;
        }
    },
    components: {
        SvgComponent, TablaSectoresComponent
    }
}
</script>